<template>
 <md-layout   class="userform" md-align="center">
  
  <transition name="fade">
  <experiment-choice v-if='isAuth'></experiment-choice>
  
  
  <md-card md-with-hover class="user-form-card" v-else >
        
       <md-card-content>
        <md-tabs>
        
          <md-tab id="signin-tab" md-label="Sign In">
            <form class="user-form" id="login_form" v-on:submit="performLogin">    
             <md-input-container>
               <label>Login</label>
               <md-input placeholder="Login" name="login" v-model="login" required></md-input>
             </md-input-container>
             <md-input-container>
               <label>Password</label>
               <md-input placeholder="Password" name="password" type="password" v-model="password" required></md-input>
             </md-input-container>
             <md-button class="md-raised md-primary" type="submit"  style="color:#fff" >Sign In</md-button>
            </form>
          </md-tab>
          <md-tab id="register-tab" md-label="Register">
            <form class="user-form" id="register_form" v-on:submit="performRegister">
              <md-input-container>
                <label>Username</label>
                <md-input placeholder="Username" name="username" v-model="username" required></md-input>
              </md-input-container>
              <md-input-container>
                <label>Email</label>
                <md-input placeholder="Email" name="email" type="email" v-model="email" required></md-input>
              </md-input-container>
              <md-input-container>
               <label>Password</label>
               <md-input placeholder="Password" name="password1" type="password" v-model="password1" required></md-input>
             </md-input-container>
             <md-input-container>
               <label>Repeat Password</label>
               <md-input placeholder="Repeat Password" name="password2" type="password" v-model="password2" required></md-input>
             </md-input-container>
                       
               <md-checkbox id="terms-checkbox"  name="terms" required></md-checkbox> I agree to <a href="/static/Terms_and_conditions.pdf" target="_blank">Terms and Conditions</a>
             <br/>
             <br/> 
             <md-button class="md-raised md-primary" type="submit" style="color:#fff">Create Account</md-button>
            </form>   
          </md-tab>
        </md-tabs>  
       </md-card-content>
       
       
       
     </md-card>
  </transition>
  
 </md-layout>
</template>

<script>
import ExperimentChoice from './ExperimentChoice'

export default{
	name: 'testpage',
	props: ['message'],
	components: {
		  ExperimentChoice,
	    },
	data(){
		return {
			testvar: 'This is test VAR',
			login: null,
			password: null,
			username: null,
			email: null,
			password1: null,
			password2: null
			
		}
	},
	created() {
		//this.$store.dispatch('getMolecules')
    },
	computed: {
		isAuth(){
			return this.$store.getters.isLoggedIn
		}
	},
	methods: {
		performLogin(event) {
			event.preventDefault();
			this.$store.dispatch('login', {
				  login: this.login,
				  password: this.password
				})
		},
		performLogout() {
			this.$store.dispatch('logout')
		},
		performRegister(){
			event.preventDefault();
			this.$store.dispatch('register', {
				  username: this.username,
				  email: this.email,
				  password1: this.password1,
				  password2: this.password2
				})
			
		}
	}
}
</script>

<style>
.userform{
    
}
.user-form-card {
  width: 80%;
  margin-bottom:100px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0
}
</style>


// WEBPACK FOOTER //
// UserForm.vue?e05d9124